export const LABEL_BG_STYLE = {
  backgroundColor: '#094B84',
  paddingY: 1.5,
  paddingX: 2,
  textAlign: 'center',
};

export const LABEL_STYLE = {
  color: '#fff',
  fontWeight: 'bold',
  fontSize: { xs: 12, md: 16, lg: 18 },
  fontFamily: "'Segoe UI Bold', wf_segoe-ui_bold, helvetica, arial, sans-serif",
};

export const CARD_STYLE = {
  width: '100%',
  margin: '1rem auto',
};

export const TABULAR_CARD_STYLE = {
  width: '100%',
  minWidth: { xl: '1300px' },
  '@media (max-width:1563px)': {
    minWidth: '1140px',
  },
  '@media (max-width:1410px)': {
    minWidth: '1100px',
  },
  '@media (max-width:1360px)': {
    minWidth: '920px',
  },
  '@media (max-width:1200px)': {
    minWidth: '850px',
  },
  '@media (max-width:1100px)': {
    minWidth: '800px',
  },
  '@media (max-width:1000px)': {
    minWidth: '600px',
  },
  '@media (max-width:800px)': {
    minWidth: '450px',
  },
};

export const CARD_HEADER_TITLE_STYLE = {
  fontWeight: 400,
  fontSize: 13.5,
};

export const CARD_CONTENT_STYLE = {
  bgcolor: '#ffffff',
  px: 20,
};

export const HEADER_STYLE = {
  fontSize: { xs: 10, sm: 10, md: 11.5, lg: 12.5, xl: 13.8 },
  fontFamily: "'Segoe UI Bold', wf_segoe-ui_bold, helvetica, arial, sans-serif",
};

export const RATE_HEADER_STYLE = {
  fontSize: { xs: 8, sm: 8, md: 9, lg: 10 },
  lineHeight: 1.4,
  py: 1,
};

export const ROW_STYLE = {
  fontSize: { xs: 9, sm: 9.5, md: 11, lg: 13 },
};

export const RATE_ROW_STYLE = {
  fontSize: { xs: 7, sm: 8, md: 9, lg: 10 },
  py: 0,
};

export const CONSORTIA_ROW_STYLE = {
  fontSize: { xs: 8, sm: 9, md: 10, lg: 11 },
  py: 0,
};
export const CONSORTIA_HEADER_STYLE = {
  fontSize: { xs: 9, sm: 9, md: 10.5, lg: 11.5 },
  lineHeight: 1.4,
  py: 1,
};
export const CONSORTIA_CARD_CONTENT_STYLE = {
  bgcolor: '#ffffff',
  px: 20,
};

export const EXPORT_PDF_BUTTON_STYLE = {
  '& .MuiSvgIcon-root': {
    width: '1.5rem',
    height: '1.25rem',
    marginRight: 2,
  },
};

export const exportPdfTextStyle = (isLoading) => ({
  mr: 1,
  mb: 0.2,
  color: isLoading ? 'gray' : 'black',
});
export const MUI_TABULAR_CONTAINER_STYLE = {
  width: '100%',
  flexGrow: 24,
  '@media (min-width:1919px)': {
    px: 31,
  },
  '@media (min-width:1900px) and (max-width:1919px)': {
    px: 30,
  },
  '@media (min-width:1785px) and (max-width:1899px)': {
    px: 26,
  },
  '@media (min-width:1700px) and (max-width:1784px)': {
    px: 18,
  },
  '@media (min-width:1600px) and (max-width:1699px)': {
    px: 6,
  },
  '@media (min-width:1500px) and (max-width:1599px)': {
    px: 12,
  },
  '@media (min-width:1400px) and (max-width:1499px)': {
    px: 4,
  },
  '@media (min-width:1300px) and (max-width:1399px)': {
    px: 5,
  },
  '@media (min-width:1200px) and (max-width:1299px)': {
    px: 12,
  },
  '@media (min-width:1100px) and (max-width:1199px)': {
    px: 15,
  },
  '@media (min-width:1000px) and (max-width:1099px)': {
    px: 14.5,
  },
  '@media (max-width:1000px)': {
    minWidth: '1200px',
  },
  mt: 2,
};

export const COLUMN_INFO_BOX_STYLE = {
  display: 'flex',
  flexWrap: 'wrap',
  gap: 4,
  justifyContent: 'flex-start',
  alignItems: 'center',
  p: 2,
  mt: 2,
};
export const COLUMN_INFO_TYPOGRAPHY_STYLE = {
  whiteSpace: 'nowrap',
  fontSize: 11,
  fontFamily: "'Segoe UI', wf_segoe-ui_normal, helvetica, arial, sans-serif",
};
